import { Injectable } from '@angular/core';
import { ClrCommonStringsService } from '@clr/angular';
import { TranslateService } from '@ngx-translate/core';
import { French } from '../models/clrInternazionalitation/clrInt.model';
import { English } from '../models/clrInternazionalitation/clrIntEn.model';
import { Spanish } from '../models/clrInternazionalitation/clrIntEs.model';

@Injectable({
  providedIn: 'root'
})
export class InternationalizationService {

  constructor(private readonly translate: TranslateService,private readonly commonStrings: ClrCommonStringsService) {
    
   }
  

  initialize() {
    this.translate.addLangs(['en', 'fr', 'es']);
    this.translate.setDefaultLang('en');
    // Get Language from localstorage or as a parameter in function
    const currentLang = localStorage.getItem('current_lang') ? localStorage.getItem('current_lang') : 'en';
    this.translate.use(currentLang);
    if(currentLang === 'en') {
      this.commonStrings.localize(English);
    } else if(currentLang === 'fr') {
      this.commonStrings.localize(French);
    } else {
      this.commonStrings.localize(Spanish);
    }
    
  }

  getTranslateVal(key) {
    return this.translate.instant(key);
  }

}
